export class FauxCheckoutForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.sections = window.BAO.sectionRenderer.pushCartSections
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'submit', this.handleSubmit)
  }

  async handleSubmit (e) {
    e.preventDefault()

    const unavailableItems = document.querySelectorAll(
      '[data-faux-checkout-form-external-el="unavailable"]',
    )
    const keys = [...unavailableItems].map(item => item.dataset.key)

    if (keys.length > 0) {
      await this.removeUnavailableItems(keys)
    } else {
      this.continueToCheckout()
    }
  }

  async removeUnavailableItems (keys) {
    try {
      const state = await window.BAO.Cart.removeItems(keys, {
        sections: this.mappedSections,
      })

      if ('sections' in state) this.renderCartSections(state.sections)
    } catch (error) {
      console.error('Cart cleanup failed (continuing anyway):', error)
    }

    this.continueToCheckout()
  }

  renderCartSections (sections) {
    const sectionsToRender = this.sections
      .map(section => {
        const sectionToRender = sections[section.section]

        if (!sectionToRender) return null

        return {
          ...section,
          html: sections[section.section],
        }
      })
      .filter(Boolean)

    window.BAO.sectionRenderer.renderMultiple(sectionsToRender)
  }

  get mappedSections () {
    return this.sections.map(s => s.section)
  }

  continueToCheckout () {
    document
      .querySelector('[data-faux-checkout-form-external-el="submit"]')
      ?.click()
  }
}

if (!customElements.get('faux-checkout-form')) {
  customElements.define('faux-checkout-form', FauxCheckoutForm, {
    extends: 'form',
  })
}
